import { Flex, Grid, GridItem } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import { useAuth } from '@r-client/shared/data/auth';
import type { BaseQueryModel } from '@r-client/shared/data/client';
import { Box, Button, Text } from '@r-client/shared/ui/core';

import styles from './query-error.module.scss';

/* eslint-disable @typescript-eslint/no-explicit-any */
type IQuery = BaseQueryModel<any, any>;

export interface IQueryErrorProps {
  queries: IQuery[];
  showLogout?: boolean;
  showRefetch?: boolean;
  showGoBack?: boolean;
  showReload?: boolean;
  showNothing?: boolean;
  userErrorMessage?: string;
}

export const QueryError = ({
  queries,
  userErrorMessage = 'Something went wrong',
  showLogout,
  showGoBack,
  showReload,
  showRefetch,
  showNothing,
}: IQueryErrorProps) => {
  const router = useRouter();

  const handleRefetch = () => {
    if (showRefetch) {
      queries.forEach((query) => {
        return query.refetch();
      });
    }
  };

  const { signOut } = useAuth();
  const handleLogout = () => {
    signOut({ redirectTo: '/logout' });
  };

  const handleGoBack = () => {
    router.back();
  };

  const handleReload = () => {
    router.reload();
  };

  if (showNothing) {
    return null;
  }

  return (
    <Box>
      <Grid templateColumns="repeat(24, 1fr)" gap={4}>
        <GridItem colSpan={24} textAlign="center">
          <Text type="bodyBig" weight="600">
            {userErrorMessage}
          </Text>
        </GridItem>

        <GridItem
          as={Flex}
          colSpan={24}
          className={styles.options}
          justifyContent="center"
          alignItems="center"
          mt={2}
          gap={6}
        >
          {showRefetch && (
            <Button type="link" size="small" onClick={handleRefetch}>
              Try Again
            </Button>
          )}
          {showReload && (
            <Button type="link" size="small" onClick={handleReload}>
              Refresh Page
            </Button>
          )}
          {showGoBack && (
            <Button type="link" size="small" onClick={handleGoBack}>
              Go Back
            </Button>
          )}
          {showLogout && (
            <Button type="link" size="small" onClick={handleLogout}>
              Logout
            </Button>
          )}
        </GridItem>
      </Grid>
    </Box>
  );
};
